import { IDeleteChecklistServicoUseCase } from "../../../presentation/useCases/delete/delete_checklist_servico_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteChecklistServicoUseCase
 */

export class DeleteChecklistServicoUseCase implements IDeleteChecklistServicoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async deleteChecklistServico(
    idChecklistServico: number,
  ): Promise<void> {
    await this.repository.deleteChecklistServico(
      idChecklistServico,
    );
  }
}
